import db from "../database";
import { findOpenPreparedBillForCart, adoptPreparedBill, explainOpenPreparedBillsOnTable } from "./cartIdentityGuard";
import { logSequenceEvent } from "./sequenceAudit";

/**
 * BUG-2425 trace: written to sequenceAuditLog (Chrome tills) and to the console with a
 * fixed tag, because CW Browser's SQLite has no sequenceAuditLog table — its console log
 * is what support can export there. Never throws.
 */
export const tracePreparedBill = (event, details = {}) => {
  try {
    logSequenceEvent(event, details, db);
  } catch {
    /* best-effort */
  }
  try {
    console.warn("[BUG-2425-TRACE]", event, JSON.stringify(details));
  } catch {
    /* best-effort */
  }
};

/**
 * BUG-2425: when a dine-in cart has lost its Prepare-Bill identity but is the same
 * table session as an open prepared bill (see findOpenPreparedBillForCart), return
 * the cart carrying that bill's identity so Prepare Bill reprints it and payment
 * confirms it, instead of creating a second order and leaving the first un-invoiced.
 * Returns null when there is nothing to recover. When the table has open prepared
 * bills that are not reused, traces which and why. Best-effort: never throws.
 */
export const recoverOpenPreparedBill = async (cart, flow) => {
  try {
    if (!cart?.tableId || cart.preparedBillOrigin === "Y" || !(cart.items || []).some((i) => i?.fbOrderLineId)) return null;
    // toArray + JS filter: .filter() closures are lost over the CW Browser SQLite bridge
    const orders = await db.orders.toArray();
    const bill = findOpenPreparedBillForCart({ cart, orders });
    if (!bill) {
      const notReused = explainOpenPreparedBillsOnTable({ cart, orders });
      if (notReused.length > 0) {
        tracePreparedBill("prepared-bill-not-reused", {
          flow,
          cartSOrderID: cart.sOrderID,
          cartDocumentno: cart.documentno,
          tableId: cart.tableId,
          reason: notReused.length > 1 ? "several-open-bills" : "lines-differ",
          openBills: notReused,
        });
      }
      return null;
    }
    tracePreparedBill("prepared-bill-recovered", {
      flow,
      sOrderID: bill.sOrderID,
      documentno: bill.documentno,
      cartSOrderID: cart.sOrderID,
      cartDocumentno: cart.documentno,
      tableId: cart.tableId,
    });
    return adoptPreparedBill(cart, bill);
  } catch {
    return null;
  }
};
